import { render, staticRenderFns } from "./Applicant.vue?vue&type=template&id=57ccfabe&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ccfabe')) {
      api.createRecord('57ccfabe', component.options)
    } else {
      api.reload('57ccfabe', component.options)
    }
    module.hot.accept("./Applicant.vue?vue&type=template&id=57ccfabe&", function () {
      api.rerender('57ccfabe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Applicant.vue"
export default component.exports